import 'css-chunksrc/client/scenes/project/secondaryCriteria/workloadSection/styles.scss';export default {
  "sectionContainer": "_sectionContainer_9x47a_1",
  "sectionRow": "_sectionRow_9x47a_9",
  "sectionLabel": "_sectionLabel_9x47a_30",
  "sectionValue": "_sectionValue_9x47a_40",
  "text": "_text_9x47a_49",
  "warning": "_warning_9x47a_54"
};